import React from "react";
import ClickablePdfPreview from "../libraryItem/course/ClickablePdfPreview";

type Props = {
  mediaUrl: string;
  onClick?: () => void;
};

const PdfPreview: React.FC<Props> = ({ mediaUrl, onClick }) => {
  return (
    <div className="flex flex-col">
      <div className="flex aspect-[128/180] w-[180px] items-center justify-center overflow-hidden rounded-2xl border border-gray-3">
        <ClickablePdfPreview
          mediaUrl={mediaUrl}
          clickableIframeProps={onClick ? { onClick } : undefined}
        />
      </div>
    </div>
  );
};

export default PdfPreview;
